import { render, staticRenderFns } from "./ChapterVIAPopup.vue?vue&type=template&id=6bc97fd4&scoped=true"
import script from "./ChapterVIAPopup.vue?vue&type=script&lang=js"
export * from "./ChapterVIAPopup.vue?vue&type=script&lang=js"
import style0 from "./ChapterVIAPopup.vue?vue&type=style&index=0&id=6bc97fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc97fd4",
  null
  
)

export default component.exports